<div [class]="'animation-hide-message containter-message '" [ngClass]="customClass?customClass:'top-[100px]'">
    <div (click)="deleteToast($event)" class="message rounded-xl flex items-center justify-center w-full h-full cursor-pointer"
        [ngClass]="{'bg-[#DF4343]': this.status === 'error','bg-[#7ED06A]':this.status === 'success'}">
        <img  *ngIf="this.status === 'error'" src="../../../assets/img/x-solid.svg" class="mr-[7.5px]"
            style="height: 12px; " />
        <img *ngIf="this.status === 'success'" src="../../../assets/img/check-solid.svg" class="mr-[10.25px]"
            style="height: 12px" />
        <div class="text-message">{{this.message}}</div>
    </div>
</div>